const acp = {
	FIRST_AUTHENTICATION_TYPE: "FIRST_AUTHENTICATION_TYPE",
};

export default acp;
